import { install as installChunkReloadHandler } from "./util/chunk-reload";
import { initConsentEnvelope } from "./util/consent-envelope";
import { initConsentLifecycle } from "./util/consent-lifecycle";
import { init as initPostHog } from "./util/posthog";
import { initSolutionsIconExperiment } from "./util/solutions-icon-experiment";
import { initTuneLinkClickIdHandler } from "./util/utm";

installChunkReloadHandler();
initConsentEnvelope();
initConsentLifecycle();
initTuneLinkClickIdHandler();
initPostHog();
initSolutionsIconExperiment();

/**
 * Load a route, then call its two lifecycle methods.
 * @param {Promise} routeImport - A dynamic import promise
 * @returns {Promise} - A promise
 */
const fire = async (routeImport) => {
  const { default: route } = await routeImport;
  route.init();
  route.finalize();
};

(() => {
  // Recommender (deferred - doesn't block page load)
  // Auto-initializes on first use, all calls safely wait for initialization
  import("./util/recommender").then((recommender) =>
    recommender.recommenderUserID()
  );

  // Common JS
  fire(import("./routes/common"));

  // Look for page specific JS

  if (document.body.classList.contains("home")) {
    fire(import("./routes/home"));
  }

  if (document.body.classList.contains("single")) {
    fire(import("./routes/single"));
  }

  if (document.body.classList.contains("single-sfwd-lessons")) {
    fire(import("./routes/single_sfwd_lessons"));
  }

  if (
    document.body.classList.contains("page") &&
    document.body.classList.contains("advertise")
  ) {
    fire(import("./routes/advertise"));
  }

  if (
    document.body.classList.contains("page") &&
    document.body.classList.contains("thank-you")
  ) {
    fire(import("./routes/thank-you"));
  }

  // Visitor-keyed "For You" box for any non-home, non-single page that
  // renders the sidebar (for example, /popular/, /category/*, /tag/*,
  // /author/*).
  // routes/home.js and routes/single.js populate #sidebar-read-next on
  // their own; this catches the rest so the sidebar isn't empty for
  // newsletter subscribers / paying members.
  if (
    document.getElementById("sidebar-read-next") &&
    !document.body.classList.contains("home") &&
    !document.body.classList.contains("single")
  ) {
    import("./util/read-next").then((m) => m.initForVisitor());
  }

  // When the document is ready, dynamically load modules for items present in the DOM
  import("./util/mtn").then((mtn) => {
    mtn.ready(() => {
      // Fire any routes that are dependent on items in the page being present
      const carousel = document.querySelector(".carousel");
      if (carousel !== null) {
        fire(import("./routes/carousel"));
      }

      const amazonBoxes = document.querySelectorAll(
        ".amazon-box:not(.loading):not(.loaded)"
      );
      if (amazonBoxes.length > 0) {
        fire(import("./routes/amazon"));
      }
    });
  });
})();
